import { useState, useCallback, useRef } from 'react'
import { getDiagnoses } from '../../../../../api/CompoundsApi'

const DEBOUNCE_MS = 400

export const useDiagnoses = () => {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const timerRef = useRef(null)

    const search = useCallback((searchString) => {
        clearTimeout(timerRef.current)

        if (!searchString?.trim()) {
            setOptions([])
            return
        }

        timerRef.current = setTimeout(async () => {
            setLoading(true)
            try {
                const { data } = await getDiagnoses(searchString)
                setOptions(data?.diagnoses ?? [])
            } catch {
                setOptions([])
            } finally {
                setLoading(false)
            }
        }, DEBOUNCE_MS)
    }, [])

    const reset = useCallback(() => {
        clearTimeout(timerRef.current)
        setOptions([])
    }, [])

    return { options, loading, search, reset }
}
